import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=712af2a6&scoped=true&"
import script from "./LoginModal.vue?vue&type=script&lang=ts&"
export * from "./LoginModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712af2a6",
  null
  
)

export default component.exports